import { createFileRoute } from "@tanstack/react-router";
import { EnumGroupDetailPage } from "../../../../components/system/EnumGroupDetailPage";
import { requireSuperAdmin } from "../../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/data-catalog/enum-groups/$groupId/")({
  beforeLoad: requireSuperAdmin(),
  component: EnumGroupDetailRoute,
});

function EnumGroupDetailRoute() {
  const { groupId } = Route.useParams();
  return <EnumGroupDetailPage groupId={groupId} />;
}
